enum ENonBenefitSymptomId {
  Hairloss = '9',
  Contraceptive = '10',
  Acne = '11',
  Diet = '12',
  GongJinDan = '109',
  OrientalBeauty = '605',
  OtherOrientalTreatments = '610',
  Rosacea = '625',
}

enum SymptomId {
  PanicAnxiety = '8',
  Depression = '588',
  OtherMentalDisorders = '589',
}

export enum EDeprecatedCategoryType {
  Symptom = 'symptom',
  Subject = 'subject',
  Vaccination = 'vaccination',
}

export enum ECategoryType {
  Treatment = 'treatment',
  Department = 'department',
  Vaccination = 'vaccination',
}

enum EDepartmentId {
  Psychiatry = '7',
  Dermatology = '6',
  PlasticSurgery = '12',
  OrientalMedicine = '19',
}

export default class DiagnosisCategoryService {
  static getDiagnosisCategoryType = (deprecatedType: EDeprecatedCategoryType): ECategoryType => {
    switch (deprecatedType) {
      case EDeprecatedCategoryType.Subject:
        return ECategoryType.Department;
      case EDeprecatedCategoryType.Symptom:
        return ECategoryType.Treatment;
      case EDeprecatedCategoryType.Vaccination:
        return ECategoryType.Vaccination;
    }
  };

  static getDeprecatedCategoryType = (categoryType: ECategoryType): EDeprecatedCategoryType => {
    switch (categoryType) {
      case ECategoryType.Department:
        return EDeprecatedCategoryType.Subject;
      case ECategoryType.Treatment:
        return EDeprecatedCategoryType.Symptom;
      case ECategoryType.Vaccination:
        return EDeprecatedCategoryType.Vaccination;
    }
  };

  static shouldShowPriceCategory(type?: ECategoryType, categoryId?: string): boolean {
    if (!type || !categoryId) {
      return false;
    }
    switch (type) {
      case ECategoryType.Treatment:
        switch (categoryId) {
          case SymptomId.PanicAnxiety:
          case SymptomId.Depression:
          case SymptomId.OtherMentalDisorders:
          case ENonBenefitSymptomId.OrientalBeauty:
          case ENonBenefitSymptomId.GongJinDan:
          case ENonBenefitSymptomId.OtherOrientalTreatments:
            return false;
          default:
            return true;
        }
      case ECategoryType.Department:
        switch (categoryId) {
          case EDepartmentId.Dermatology:
          case EDepartmentId.Psychiatry:
          case EDepartmentId.PlasticSurgery:
          case EDepartmentId.OrientalMedicine:
            return false;
          default:
            return true;
        }
      default:
        return true;
    }
  }

  static isNonBenefitCategory(type?: ECategoryType, categoryId?: string): boolean {
    if (!type || !categoryId) {
      return false;
    }
    switch (type) {
      case ECategoryType.Treatment: {
        switch (categoryId) {
          case ENonBenefitSymptomId.Hairloss:
          case ENonBenefitSymptomId.Acne:
          case ENonBenefitSymptomId.Contraceptive:
          case ENonBenefitSymptomId.Diet:
          case ENonBenefitSymptomId.GongJinDan:
          case ENonBenefitSymptomId.OrientalBeauty:
          case ENonBenefitSymptomId.OtherOrientalTreatments:
          case ENonBenefitSymptomId.Rosacea:
            return true;
          default:
            return false;
        }
      }
      case ECategoryType.Department: {
        return false;
      }
      case ECategoryType.Vaccination: {
        return false;
      }
    }
  }

  static isDietCategory(categoryId?: string): boolean {
    if (!categoryId) {
      return false;
    }
    return categoryId === ENonBenefitSymptomId.Diet;
  }
}
